import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  id: string;
  ariaControl: string;
}

export function CustomTabPanel({ children, value, index, id, ariaControl, ...props }: TabPanelProps) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`${id}-${index}`}
      aria-labelledby={`${ariaControl}-${index}`}
      {...props}
    >
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
}

export function a11yProps(id: string, ariaControl: string | number, index: number | string) {
  return {
    id: `${id}-${index}`,
    'aria-controls': `${ariaControl}-${index}`
  };
}
